import React, { useEffect } from "react";
import casino from "../Images/casino.webp";
import familiar from "../Images/familiar.webp";
import safari from "../Images/safari.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Tooltip } from "bootstrap";

const Artigas = () => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);

  return (
    <div className="container">
      <h2 className="text-center">Explorá Artigas</h2>
      <h5 className="text-center">
        Si visitás Bella Unión, también estás a las puertas de descubrir el departamento de Artigas: piedras
        preciosas, cultura, naturaleza y experiencias únicas.
      </h5>
      <div className="row align-items-stretch g-3 mt-5">
        <div className="col-xxl-8">
          <h3 className="text-center">Alojamientos</h3>
          <div className="row g-3 align-items-stretch mt-3">
            <div className="col-md-6">
              <div className="bg-white shadow rounded">
                <div
                  className={`add-img w-100 rounded-top shadow`}
                  style={{ backgroundImage: `url(${casino})`, aspectRatio: "2 / 2" }}
                />
                <div className="p-3 text-center">
                  <h2>Hotel Casino San Eugenio del Cuareim</h2>
                  <p>
                    Ubicado en el corazón de Artigas, en el cruce de la Av. Cnel. Carlos Lecueder y Luis A. de
                    Herrera, el Hotel Casino San Eugenio del Cuareim te recibe con la calidez de la
                    hospitalidad artiguense y un servicio excpcional en un hotel único.
                  </p>
                  <h4>Contacto</h4>
                  <a
                    href={"https://wa.me/59892249504"}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviales un Whatsapp"
                  >
                    <FontAwesomeIcon className="text-success fs-2" icon={faWhatsapp} />
                  </a>
                  <a
                    href={`tel:+59892249504`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono móvil"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#0D47A1" }} icon={faMobileScreen} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-white shadow rounded h-100">
                <div
                  className={`add-img w-100 rounded-top shadow`}
                  style={{ backgroundImage: `url(${familiar})`, aspectRatio: "2 / 2" }}
                />
                <div className="p-3 text-center">
                  <h2>Hostel Familiar Artigas</h2>
                  <p>
                    Un hostel amplio, cómodo y lleno de luz — tu casa lejos de casa. Ambiente tranquilo,
                    seguro y lleno de paz, con atención familiar y la calidez que tu viaje merece.
                  </p>
                  <h4>Contacto</h4>
                  <a
                    href={"https://wa.me/59899392326"}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviales un Whatsapp"
                  >
                    <FontAwesomeIcon className="text-success fs-2" icon={faWhatsapp} />
                  </a>
                  <a
                    href={`tel:+59899392326`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono móvil"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#0D47A1" }} icon={faMobileScreen} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-4">
          <h3 className="text-center">Actividades</h3>
          <div className="row g-3 align-items-stretch mt-3 justify-content-center">
            <div className="col">
              <div className="bg-white shadow rounded">
                <div
                  className={`add-img w-100 rounded-top shadow`}
                  style={{ backgroundImage: `url(${safari})`, aspectRatio: "2 / 2" }}
                />
                <div className="p-3 text-center">
                  <h2>Safari Minero</h2>
                  <p>
                    Acompañados por un guía, viví una excursión única que te permite conocer el origen de las
                    ágatas y descubrir las amatistas de mayor pureza de la región.
                  </p>
                  <h4>Contacto</h4>
                  <a
                    href={"https://wa.me/59892249505"}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviales un Whatsapp"
                  >
                    <FontAwesomeIcon className="text-success fs-2" icon={faWhatsapp} />
                  </a>
                  <a
                    href={`tel:+59892249505`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono móvil"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#0D47A1" }} icon={faMobileScreen} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Artigas;
